import OvumLogo from './Ovum';
import PatientBudLogo from './PatientBudLogo';
import ABCHospital from './ABCHospitalLogo';
import StLukeLogo from './StLuke';

export const logoNameMap: { [key: string]: React.FC<{ width?: number; height?: number; id?: string }> } = {
  Ovum: ({ width, height, id }) => <OvumLogo width={width} height={height} id={id} />,
  PatientBud: ({ width, height }) => <PatientBudLogo width={width} height={height} />,
  AbcHospital: ({ width, height }) => <ABCHospital width={width} height={height} />,
  StLuke: ({ width, height }) => <StLukeLogo width={width} height={height} />,
};
